import useAppStore from 'store/useAppStore';
import { getScript } from './getScript';

const getAllSegScriptForApi = () => {
  const scripts = useAppStore.getState().scripts;
  return scripts.map(({ id, ...others }) => {
    const data = {};
    useAppStore.getState().scriptKeys.forEach((key) => {
      data[key] = others[key];
    });
    return {
      seg_script_id: id,
      seg_script_info: getScript(data),
    };
  });
};
export default getAllSegScriptForApi;
